module.exports = __webpack_public_path__ + "img/bg-download-section-2.45516410.webp";